/* istanbul ignore file */
import AmazonDemandSidePlatform from './amazonDemandSidePlatform';
import AmazonSellerCentralPos from './amazonSellerCentralPos';
import AmazonSearchAdvertisingGas from './amazonSearchAdvertisingGas';
import AmazonVendorCentralPos from './amazonVendorCentralPos';
import CriteoRetailMedia from './criteoRetailMedia';
import TargetRoundel from './targetRoundelAdvertising';
import WalmartConnectAdvertising from './walmartConnectAdvertising';
import { DataCollectionAccountWithSettings } from '../../controllers/subscription-service/types';
import sendRumError from '../datadogRum';
import { hasGrants } from '../../controllers/auth';

// temp export
export const DataCollectionConfigs = [
  AmazonDemandSidePlatform,
  AmazonSearchAdvertisingGas,
  AmazonSellerCentralPos,
  AmazonVendorCentralPos,
  CriteoRetailMedia,
  TargetRoundel,
  WalmartConnectAdvertising,
];

export default {
  AmazonDemandSidePlatform,
  AmazonSearchAdvertisingGas,
  AmazonSellerCentralPos,
  AmazonVendorCentralPos,
  CriteoRetailMedia,
  TargetRoundel,
  WalmartConnectAdvertising,
};

export const SubscriptionSettingUniqueValues = Object.assign(
  {},
  ...(DataCollectionConfigs.map((config) => config.SubscriptionSettingUniqueValues)),
);

export const SubscriptionQueryTranslations = Object.assign(
  {},
  ...(DataCollectionConfigs.map((config) => config.subscriptionQueryTranslations)),
);

export const DCAInstructionsComponent: Record<string, React.ReactNode> = Object.assign(
  {},
  ...(DataCollectionConfigs.map((config) => config.dcaInstructionsComponent)),
);

export const DisableAccountNameEntry: string[] = DataCollectionConfigs
  .flatMap((config) => config.disableAccountNameEntry as string[]);

export const OrganizationAdminVisibleOfferedSubscriptions: string[] = DataCollectionConfigs
  .flatMap((config) => config.visibleOfferedSubscriptions as string[]);

type ValidateAndAuthorizeReturn = {
  hasRequiredSettings: boolean;
  authorize: (dca: DataCollectionAccountWithSettings) => undefined | void | Error;
};

export const validateAndAuthorize = (
  dca: DataCollectionAccountWithSettings,
):ValidateAndAuthorizeReturn => {
  try {
    const config = DataCollectionConfigs.find(
      (c) => c.isConfig(dca),
    );

    const hasRequiredSettings = config?.hasRequiredSettings(dca) || false;

    // fails because we're not finding config.. and so we can't authorize...
    return {
      hasRequiredSettings: !!hasRequiredSettings,
      authorize: config?.authorize || (() => undefined),
    };
  } catch (e) {
    sendRumError(e);
    return {
      hasRequiredSettings: false,
      authorize: () => e as Error,
    };
  }
};

export const hasSufficientGrants = (
  currentOrgId: number,
  offeredSubscriptionId: string,
):boolean => {
  try {
    // locate the correct interface, and yes, I had to cast to string
    const config = DataCollectionConfigs.find(
      (c) => c.visibleOfferedSubscriptions.map((s) => String(s)).includes(offeredSubscriptionId),
    );

    return hasGrants(currentOrgId, config?.requiredGrants.org, config?.requiredGrants.zero);
  } catch (e) {
    sendRumError(e);
    return false;
  }
};
